import { Injectable } from '@angular/core';
import { LoadingController } from 'ionic-angular';
import { FirebaseData } from '../../../providers/firebase-data';
import { FirebaseStorage } from '../../../providers/firebase-storage';
import { Observable } from 'rxjs/Observable';
import { FireBaseObjectNames } from '../../../core/codes';
import { Utils } from '../../../providers/utils';
import firebase from 'firebase';

@Injectable()
export class AccountData {
    public realtimeDb: any;
    public ordersList: any;
    public nameInitials: string;

    constructor(
        private firebaseData: FirebaseData, 
        private firebaseStorage: FirebaseStorage,
        public loadingCtrl: LoadingController,
    ) {
      this.realtimeDb = firebase.database();
    }

    public getOrdersData(userId){
        var self = this;
        return Observable.create((observer) =>{
            self.realtimeDb.ref(FireBaseObjectNames.ORDERS + '/'+ userId).on('value', data => {
                let items = {};
                if(data){
                    items = Utils.toArray(data.val());
                }
                observer.next(items);
            });
        });
    }

    public getShoppingListData(userId){
        var self = this;
        return Observable.create((observer) =>{
            self.realtimeDb.ref(FireBaseObjectNames.SHOPPING_LIST + '/'+ userId).on('value', data => {
                let items = {};
                if(data){
                    items = Utils.toArray(data.val());
                }
                observer.next(items);
            });
        });
    }
    
}


// WEBPACK FOOTER //
// ./src/modules/account/providers/account-data.ts